import { ThunkAction } from 'redux-thunk';
import { IContext, IState } from '../index';
import { ICreateMessageForOfferRequest } from '../../repositories/demand/v2/create-message-for-offer';
import { demandLastRequestedData } from '@cian/demand-trap-widget';
import { sendDemandRequest } from '../demand/demandThunk';

export const verifyPhoneRetry = (): ThunkAction<void, IState, IContext> => {
  return (dispatch, getState) => {
    const state = getState();
    const demandData: ICreateMessageForOfferRequest = demandLastRequestedData(state);

    delete demandData.confirmationCode;

    dispatch(sendDemandRequest({ ...demandData, source: 'Card' }));
  };
};
